export default {
  headerContent: {
    title: 'Mapfre Sigorta İş Yeri Sigortası Hesaplama',
    slogan: "İş Yeri Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'İŞ YERİ SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Mapfre Sigorta İş Yeri Sigortası',
    description: {
      title: 'Mapfre Sigorta İş Yeri (Paket) Sigortası Nedir? ',
      content: [
        'İş yeri sigortası, infilak, taşıt çarpması veya doğal afet gibi risklerin gerçekleşmesinden sonucunda oluşacak zararları ve bu zararlardan kaynaklı işin durması veya yavaşlaması sebebiyle yaşanacak kayıpları koruma altına almaktadır.',
        'Mapfre Sigorta iş yeri sigortası, sadece işletmeyi veya çalışanları değil müşterilerinizi ve çevrenizdekileri de koruma altına almaktadır.'
      ]
    },
    subContent: {
      title: 'Mapfre Sigorta İş Yeri (Paket) Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph: '<strong>Ana teminatlar;</strong>',
          subList: [
            'Yangın, yıldırım, infilak',
            'Dahili su',
            'Duman',
            'Fırtına',
            'Kar ağırlığı',
            'Yer kayması',
            'Yakıt sızması',
            'Taşıt çarpması',
            'Enkaz kaldırma masrafları '
          ]
        },
        {
          paragraph: '<strong>Ek Teminatlar;</strong>',
          subList: [
            'Grev, lokavt, kargaşalık, halk hareketleri, kötü niyetli hareketler, terör',
            'Deprem',
            'Yangın mali mesuliyet',
            'Kiracının mal sahibine karşı sorumluluğu',
            'Mal sahibinin kiracıya karşı sorumluluğu',
            'Mal sahibi veya kiracının komşulara karşı sorumluluğu',
            'Sel ve su baskını (seylap)',
            'Hırsızlık',
            'Cam ve ayna kırılması',
            'Yangına Bağlı Kar Kaybı',
            'Elektronik Cihaz',
            'Makine Kırılması',
            'İşveren Mali Mesuliyet',
            'Üçüncü Şahıs Mali Mesuliyet',
            'Taşınan Para',
            'Emniyeti Suistimal',
            'Ferdi Kaza'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'İş Yeri Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'İş Yeri Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'İş Yeri Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Mapfre Sigorta İş Yeri Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
